import styled from '@emotion/styled';

export const DraggableGridItemStyled = styled.div<{ isDragging?: boolean; disableDrag: boolean }>`
  opacity: ${({ isDragging }) => (isDragging ? 0 : 1)};

  &:active {
    ${({ disableDrag }) => !disableDrag && 'cursor: grabbing;'}
  }
`;
